import { render } from "./BlogImplantsGuideAfterSurgery.vue?vue&type=template&id=50e80aa4"
import script from "./BlogImplantsGuideAfterSurgery.vue?vue&type=script&lang=js"
export * from "./BlogImplantsGuideAfterSurgery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__